import ClientRenderedContent from 'components/ClientRenderedContent';
import React from 'react';

interface PriceBreakdownProps {
  taxAmount: number;
  currentPrice: number;
  isSingleCharge?: boolean;
}

const PriceBreakdown = ({ taxAmount, currentPrice, isSingleCharge }: PriceBreakdownProps) => {
  const items = [
    { label: `${isSingleCharge ? 'Subtotal' : 'Subscription'}`, amount: currentPrice },
    { label: 'Sales Tax', amount: taxAmount / 100 },
  ];

  return (
    <>
      {items.map(({ label, amount }) => (
        <div className="flex items-start justify-between" key={label}>
          <div className="font-suisse-screen text-byline-lg text-grayscale-gray">
            <ClientRenderedContent>{label}</ClientRenderedContent>
          </div>
          <div className="flex flex-col text-right">
            <span className="font-suisse-screen text-byline-lg text-grayscale-gray">
              ${amount.toFixed(2)}
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

export default PriceBreakdown;
